// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nuxt-progress{position:fixed;top:0;left:0;right:0;height:2px;width:0;opacity:1;-webkit-transition:width .1s,opacity .4s;-o-transition:width .1s,opacity .4s;transition:width .1s,opacity .4s;background-color:#e03f19;z-index:999999}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
